module.exports = __webpack_public_path__ + "static/img/lmp_image.f99edc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/1x/lmp_image.png
// module id = 4wmx
// module chunks = 1